export default "__VITE_ASSET__631af94d__"